module.exports = __webpack_public_path__ + "static/media/SmileFace.62d209e4.svg";